var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:("fflag ff-" + _vm.size + (_vm.flagId ? (" fflag-" + (_vm.flagId.toUpperCase())) : '')),style:(_vm.background ? _vm.background : '')})}
var staticRenderFns = []

export { render, staticRenderFns }